import { objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isIntegrationsDirectCdiAwsAccountIdResult = objectOf({
  aws_account_id: string,
});
